import { Component, EventEmitter, Input, Output } from '@angular/core';
import { StoreCategory, StoreSortKey } from 'src/app/model/store';

/** Busca, chips de categoria e ordenacao. Tudo client-side sobre o catalogo carregado. */
@Component({
  selector: 'app-store-filters',
  templateUrl: './store-filters.component.html',
  styleUrls: ['./store-filters.component.scss'],
})
export class StoreFiltersComponent {
  @Input() term = '';
  @Input() sort: StoreSortKey = 'RELEVANCE';
  @Input() categories: StoreCategory[] = [];
  /** null = chip "Todos". */
  @Input() selectedCategoryKey: string = null;
  @Input() totalCount = 0;

  @Output() termChange = new EventEmitter<string>();
  @Output() sortChange = new EventEmitter<StoreSortKey>();
  @Output() categoryChange = new EventEmitter<string>();

  readonly sortOptions: Array<{ key: StoreSortKey; label: string }> = [
    { key: 'RELEVANCE', label: 'clicStore.sortRelevance' },
    { key: 'POINTS_ASC', label: 'clicStore.sortPointsAsc' },
    { key: 'POINTS_DESC', label: 'clicStore.sortPointsDesc' },
    { key: 'NAME_ASC', label: 'clicStore.sortNameAsc' },
    { key: 'NAME_DESC', label: 'clicStore.sortNameDesc' },
  ];

  /** Um unico chip cobrindo tudo ao lado de "Todos" e ruido. */
  get showCategories(): boolean {
    return (this.categories || []).length > 1;
  }
}
